export const primaryColor = '#00225a';
export const secondaryColor = '#ff5e13'